import React from 'react';
import { motion } from 'framer-motion';
import { CompassIcon } from 'lucide-react';
export function About() {
  return <section className="px-5 py-24 md:py-32" data-id="element-15">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mx-auto max-w-3xl text-center" data-id="element-16">
        <CompassIcon className="mx-auto mb-5 h-7 w-7 text-gold-light" data-id="element-17" />
        <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-18">
          Una expedición entre páginas
        </p>
        <h2 className="mt-4 text-4xl font-semibold leading-tight text-stone-light md:text-6xl" data-id="element-19">
          Una colección creada para descubrir la verdadera historia de los mayas
        </h2>
        <p className="mt-6 text-lg leading-8 text-stone" data-id="element-20">
          Investigaciones, descubrimientos arqueológicos y curiosidades reunidos
          en una narrativa clara y envolvente, para recorrer el mundo maya como
          si estuvieras frente a un gran documental.
        </p>
      </motion.div>
    </section>;
}